module.exports = __webpack_public_path__ + "img/other_3.c12a5680.png";